<div [matTooltip]="getNamesOfOtherItems()" class="color-preview more-items" matTooltipPosition="above">
  <p class="no-margin">+{{ getAmountOfMoreItemsAvailable() }}</p>
</div>
